module.exports = __webpack_public_path__ + "src/assets/img/share-weibo.62870614.png";